import type { RfqInvitationId } from "../types";

export const RFQ_TAB_PATH = "/dashboard/invoice-management?tab=rfqs";

export const rfqDetailPath = (id: RfqInvitationId): string => `/dashboard/invoice-management/rfqs/${encodeURIComponent(String(id))}`;
